/* Scoped enhancements. The Shopify cart remains the price/inventory authority. */
(() => {
  'use strict';
  if (window.bpStorefrontRefinements) return;
  window.bpStorefrontRefinements = true;
  let busy = false;
  const roots = () => document.querySelectorAll('[data-bp-cart-collection]');
  const setStatus = (text) => roots().forEach(root => { const node=root.querySelector('[data-bp-shelf-status]'); if(node) node.textContent=text; });
  const setBusy = (value) => {
    busy=value;
    roots().forEach(root => {
      root.setAttribute('aria-busy',String(value));
      root.querySelectorAll('[data-bp-shelf-add]').forEach(button => { button.disabled=value || button.dataset.bpAvailable!=='true'; });
    });
  };
  async function readHelper(section) {
    const url=new URL(window.location.href);
    url.searchParams.set('section_id',section);
    const response=await fetch(url.pathname+url.search,{credentials:'same-origin',cache:'no-store',headers:{'Accept':'text/html'}});
    if(!response.ok) throw new Error('No se pudo actualizar el carrito.');
    return response.text();
  }
  function renderCart(html) {
    if(!html || !html.includes('AjaxCartForm') || !html.includes('AjaxCartSubtotal')) throw new Error('Respuesta incompleta del carrito.');
    if(typeof window.renderHelperCart!=='function') throw new Error('El carrito a\u00fan no est\u00e1 listo.');
    window.renderHelperCart(html);
    document.body.dispatchEvent(new CustomEvent('cart-updated',{bubbles:true,detail:{source:'bp-cart-collection'}}));
  }
  document.addEventListener('click', async (event) => {
    const button=event.target.closest('[data-bp-shelf-add]');
    if(!button) return;
    event.preventDefault();
    if(busy || button.disabled) return;
    const root=button.closest('[data-bp-cart-collection]');
    const id=Number(button.dataset.bpShelfAdd);
    if(!root || !Number.isSafeInteger(id) || id<=0) return;
    const addURL=new URL(root.dataset.bpAddUrl,window.location.origin);
    if(addURL.origin!==window.location.origin) return;
    const section=(window.KT_FILE_PREFIX||'')+'helper-cart';
    let accepted=false;
    let responseReceived=false;
    setBusy(true);setStatus('A\u00f1adiendo al carrito\u2026');
    try {
      const response=await fetch(addURL.pathname+addURL.search,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id,quantity:1}],sections:[section],sections_url:window.location.pathname})});
      responseReceived=true;
      if(!response.ok){
        const error=await response.json().catch(()=>({}));
        throw new Error(error.description||error.message||'No se pudo a\u00f1adir este ejemplar.');
      }
      accepted=true;
      const result=await response.json();
      const html=result.sections && result.sections[section] ? result.sections[section] : await readHelper(section);
      renderCart(html);
      setStatus('Ejemplar a\u00f1adido. El total del carrito ya est\u00e1 actualizado.');
    } catch(error) {
      if(accepted){
        try {renderCart(await readHelper(section));setStatus('Ejemplar a\u00f1adido. El total del carrito ya est\u00e1 actualizado.');}
        catch {setStatus('El ejemplar se a\u00f1adi\u00f3, pero la vista no pudo actualizarse. Actualiza la p\u00e1gina antes de a\u00f1adirlo otra vez.');}
      } else if(!responseReceived) {
        setStatus('Se interrumpi\u00f3 la conexi\u00f3n. Revisa el carrito o actualiza la p\u00e1gina antes de repetir, para evitar duplicados.');
      } else setStatus(error.message||'No se pudo a\u00f1adir este ejemplar.');
    } finally {setBusy(false);}
  });
  function installFAQ(scope=document) {
    scope.querySelectorAll('info-tabs').forEach(root => {
      if(root.dataset.bpFaq || !root.querySelector('#info-tab-tab_KWzwJG')) return;
      root.dataset.bpFaq='true';
      const tabs=[...root.querySelectorAll('.js-info-tab')];
      const togglers=root.querySelector('.info-tabs_togglers');
      const panels=root.querySelector('.info-tabs_panels');
      if(!togglers || !panels) return;
      let frame=0;
      const align=()=>{
        frame=0;
        const active=root.querySelector('.js-info-tab.active')||tabs[0];
        tabs.forEach(tab=>tab.setAttribute('aria-expanded',String(tab===active)));
        const y=window.matchMedia('(min-width:768px)').matches ? Math.max(0,active.getBoundingClientRect().top-root.getBoundingClientRect().top+(parseFloat(getComputedStyle(active).paddingTop)||0)) : 0;
        const val=Math.round(y)+'px';
        if(root.style.getPropertyValue('--bp-faq-y')!==val) root.style.setProperty('--bp-faq-y',val);
      };
      const schedule=()=>{if(!frame) frame=requestAnimationFrame(align);};
      tabs.forEach(tab=>{
        tab.setAttribute('role','button');tab.tabIndex=0;
        tab.addEventListener('keydown',event=>{if(event.key==='Enter'||event.key===' '){event.preventDefault();tab.click();}});
        new MutationObserver(schedule).observe(tab,{attributes:true,attributeFilter:['class']});
      });
      if(window.ResizeObserver) new ResizeObserver(schedule).observe(togglers);
      window.addEventListener('resize',schedule,{passive:true});
      root.addEventListener('click',()=>{schedule();setTimeout(schedule,240);});
      if(document.fonts) document.fonts.ready.then(schedule);
      schedule();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>installFAQ());else installFAQ();
  document.addEventListener('shopify:section:load',()=>installFAQ());
})();
